import { Button } from '@chakra-ui/react';
import React, { useState, useEffect, useRef} from 'react';
import { IoMdClose } from 'react-icons/io';
import { useCartContext } from '../../context/cart_context';
import { useFilterContext } from '../../context/filter_context';
import axios from 'axios';
import { useUserContext } from '../../context/user_context';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import { useDisclosure } from '@chakra-ui/react';
import { formatPrice } from '../../utils/helpers';
const WishlistPopup = ({ onClose }) => {
  const { addToCart } = useCartContext();
  const [wishlistData, setWishlistData] = useState([]);
  const { filtered_products: products, grid_view } = useFilterContext();
  const { currentUser } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);
  const { handlecartButton, setMainColor } = useCartContext();
  const { isOpen, onOpen } = useDisclosure();
  const [cartButtonText, setCartButtonText] = useState('');
  const menuRef=useRef()
  const handleRemove = async (id) => {
    const data = {
      wishlistItem: id,
    };
    const userid = currentUser?.id;
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
      { data }
    );
    fetchData();
  };

  

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const userid = currentUser?.id;
      if (userid) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
        );
       
        setWishlistData(response.data.data);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching wishlist items:', error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

   React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose()
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMoveToBag = async (data, id) => {
    setIsLoading(true);
    await handlecartButton(
      data.id,
      1,
      currentUser,
      setCartButtonText,
      onOpen,
      data.productCode,
      data.bestOffers,
      data.taxPrice,
      data.weight,
      data?.discountPercentage,
      data.price,
      data.price
    );
    handleRemove(data.id);
    setIsLoading(false);
  };

  return (
    <div
      className='flex flex-col bg-white rounded-lg 
      w-[90vw] sm:w-[400px] md:w-[420px] max-h-[70vh] overflow-y-auto scroller p-4 z-[50]'
      ref={menuRef}
    >
      {isLoading && (
        <Loading className='h-full w-full flex justify-center items-center' />
      )}
      <h1 className='text-black font-semibold text-lg mb-4 text-center sm:text-left'>
        Your Wishlist{' '}
        <span className='text-[#008FAB]'>({wishlistData?.length})</span>
      </h1>

      {!isLoading && (
        <div className='flex flex-col gap-4'>
          {wishlistData?.map((e) => (
            <div
              key={e.id}
              className='border-b border-[#008FAB40] pb-3 last:border-none'
            >
              <div className='flex gap-3 sm:gap-4 items-center justify-between'>
                <img
                  src={e?.productImageUrl[0]}
                  alt={e?.description}
                  className='w-16 h-16 sm:w-20 sm:h-20 rounded-md object-cover'
                />

                <div className='flex-1 flex flex-col text-sm sm:text-base'>
                  <p className='font-medium text-gray-800 line-clamp-2 leading-tight'>
                    {e?.description}
                  </p>
                  <div className='flex gap-2 items-center mt-1'>
                    <p className='font-bold text-black text-sm sm:text-base'>
                      {formatPrice(e?.price)}
                    </p>
                    
                  </div>
                  <button
                    className='mt-2 text-xs sm:text-sm border border-[#22222280] text-[#222222] rounded-md px-2 py-1 w-fit hover:bg-[#008FAB] hover:text-white transition'
                    onClick={() => handleMoveToBag(e, e.id)}
                  >
                    Move to Bag
                  </button>
                </div>

                <IoMdClose
                  className='text-[#008FAB] cursor-pointer text-lg sm:text-xl hover:text-red-500 transition'
                  onClick={() => handleRemove(e?.id)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      <div>
        <Link
          to='/wishlist'
          onClick={(e) => {
            e.preventDefault();
            onClose();
            setTimeout(() => {
              window.location.href = '/wishlist';
            }, 50);
          }}
        >
          <Button backgroundColor={'#D3A143'} textColor={'white'}>
            View Wishlist
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default WishlistPopup;
